import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../../../../Common/ErrorBoundary';
import AppointeeDatatableView from './AppointeeDatatableView';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';
import Refiner from 'Common/Components/Refiner/Refiner.container';
import Section from 'Common/Layout/Section';
import { getRefinedQuestions, getRefinedAnswers } from '../../RefinerUtils/refinerDataSources';
import { questionMatcher, answerMatcher } from '../../RefinerUtils/refinerMatchers';

const refinerFields = [
	{ name: 'appointmentType', label: "Appt Type", type: 'list', allowEmpty: true },
	{ name: 'markingTeamTitle', label: 'Team Name contains', type: 'text' },
    { name: 'markingTeamCode', label: 'Team Code', type: 'text' },
    { name: 'question', label: 'Question', type: 'select', dataSource: getRefinedQuestions, matcher: questionMatcher },
    { name: 'answer', label: 'Answer', type: 'select', dataSource: getRefinedAnswers, matcher: answerMatcher }
];

const refinerDetailFields = [
	{ name: 'appointmentType', label: "Appt Type", type: 'list', allowEmpty: true },
	{ name: 'niNumber', label: 'NI', type: 'text' },
	{ name: 'markingTeamTitle', label: 'Team Name contains', type: 'text' },
	{ name: 'markingTeamCode', label: 'Team Code', type: 'text' },
	{ name: 'markingMethod', label: 'Marking Method', type: 'text' },
	{ name: 'placeOfEmployment', label: 'Place of Employment', type: 'text' },
	{ name: 'placeOfEmploymentCode', label: 'Place of Employment Code', type: 'text' }
];

class AppointeeDatatable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedYear: props.selectedYear,
			contractTypes: props.contractTypes,
			keyField: props.mainKeyField,
			columns: props.mainColumns,
			total: 0,
			tableData: [],
			allData: [],
			allDetailsData: [],
			apiCallCompleted: false,
			exportData: [],
			flagExportData: false,
			flagDetailsData: false,
			mainKeyField: props.mainKeyField,
			mainColumns: props.mainColumns,
			mainSearchTextInput: '',
			mainSortOrderInput: '',
			mainSortFieldInput: '',
			detailsKeyField: props.detailsKeyField,
			detailsColumns: props.detailsColumns,
			detailsSortOrderInput: '',
			detailsSortFieldInput: '',
			searchValue: '',
			selected: [0, 0],
			selectedMarkingTeamId: 0,
			selectedMarkingTeamCode: '',
			selectedRowId: 1,
			setSearchBoxBlur: true,
			setSearchFieldHit: false,
			timeout: null,
			blurSearchBoxOnPageChange: false,
			searchYear: props.selectedYear.toString(),
			updateYear: PropTypes.func.isRequired,
			isFiltering: false,
			refinerOpen: true,
			refinerDetailsOpen: true
		};

		this.state.mainColumns = this.selectableColumns;
		this.state.columns = this.selectableColumns
		this.componentRef = React.createRef();
		this.getData = this.props.handleGetData;
		this.getDataExport = this.props.handleGetDataExport;
		this.getDetailsData = this.props.handleGetDataDetails;
		this.handleChange = this.handleChange.bind(this);
		this.updateYear = this.updateYear.bind(this);
    }

	onSelectClick(row) {
		this.setState(() => ({
			selected: [...this.state.selected, row.rowId],
			selectedMarkingTeamId: row.markingTeamId,
			selectedMarkingTeamCode: row.markingTeamCode,
			selectedRowId: row.rowId,
			setSearchBoxBlur: true
		}), 
		() => this.handleSelectClick());
	}

	linkFormatter = (cell, row, rowIndex, formatExtraData) => {
		return (
			<button
				aria-label={`Select for more details on Marking Team ${row.markingTeamTitle}`}
				className="btn btn-primary btn-sm"
				style={{ width: '100px' }}
				onClick={() => this.onSelectClick(row)}
			>
			Select
		</button>
		);
	};

	selectableColumns = [
		{ dataField: 'rowId', text: 'Row ID', hidden: true, csvExport: false },
		{ 
			dataField: 'button', 
			formatter: this.linkFormatter,
			headerClasses: 'th-select-td',
			classes: 'tr-td-overflow-hide',
			isDummyField: true
		},
		{ dataField: 'markingTeamId', text: 'Marking Team ID', hidden: true },
		{
			dataField: 'qualificationYear',
			text: 'Year',
			headerClasses: 'th-td-ssx',
			classes: 'tr-td-overflow-hide'
		},
		{
			dataField: 'appointmentType',
			text: 'Type',
			sort: true,
			headerClasses: 'th-td-ssx',
			classes: 'tr-td-overflow-hide'
		},
		{
			dataField: 'markingTeamTitle',
			text: 'Marking Team Title',
			sort: true,
			headerClasses: 'th-auto-td'
		},
		{
			dataField: 'markingTeamCode',
			text: 'Code',
			sort: true,
			headerClasses: 'th-td-ms',
			classes: 'tr-td-overflow-hide',
			csvFormatter: cell => DataFormat.writeDataWithLeadingZeroInCsv(cell)
		}
	];

	handleChange(event) {
		this.setState({ searchValue: event.target.value });
		this.handleCustomizeSearch(event);
	}

	focusSearchInputField = input => {
		const { setSearchBoxBlur, setSearchFieldHit, blurSearchBoxOnPageChange } = this.state;

		if (!input) {
			return;
		}

		if ((!setSearchFieldHit && setSearchBoxBlur) || blurSearchBoxOnPageChange) {
			return false;
		}

		input.focus();
	};

	handleCustomizeSearch = event => {
		this.setState({
			setSearchFieldHit: true,
			blurSearchBoxOnPageChange: false
		});
		const { timeout } = this.state;
		clearTimeout(timeout);
		this.setState({
			timeout: setTimeout(() => {
				this.getSearchData();
			}, 1000)
		});
	};

	componentDidMount = () => {
		const { mainKeyField, searchValue, pageNoInit, pageSizeInit, flagExportData } = this.state;
		let sortOrder = 'asc',
			sortField = mainKeyField;
		this.loadMainData(searchValue, pageNoInit, pageSizeInit, flagExportData, sortOrder, sortField);
	};

	loadMainData = async (searchInput, pageNoInput, pazeSizeInput, flagExportData, sortOrder, sortField, dynamicFunction) => {
		const { contractTypes, mainKeyField } = this.state;
		sortOrder = sortOrder ? sortOrder : 'asc';
		sortField = sortField ? sortField : mainKeyField;
		let query = {
			sortOrder,
			sortField,
			page: pageNoInput,
			sizePerPage: pazeSizeInput,
			searchText: searchInput,
			flagExportData
		};

		if (flagExportData === false) {
			await this.getData(this.state.searchYear, contractTypes, query);

			let markingTeamId = 0,
				markingTeamCode = '',
				items = [],
				tableData = this.props.mainTableData[0].data || [],
				allData = tableData;
			if (tableData.length > 0) {
				items = tableData[0];
				if (typeof items != 'undefined') {
					markingTeamId = items.markingTeamId;
					markingTeamCode = items['markingTeamCode'];
				}
			}

			this.setState({
				...this.state,
				setSearchBoxBlur: true,
				keyField: mainKeyField,
				pageNo: pageNoInput,
				pageSize: pazeSizeInput,
				mainPageNo: pageNoInput,
				mainPageSize: pazeSizeInput,
				mainSearchTextInput: searchInput,
				mainSortOrderInput: sortOrder,
				mainSortFieldInput: sortField,
				selectedMarkingTeamId: markingTeamId,
				selectedMarkingTeamCode: markingTeamCode,
				selectedRowId: 1,
				apiCallCompleted: this.props.apiCallCompleted,
				total: this.props.mainTableData[0].total,
				tableData: this.props.mainTableData[0].data,
				allData: this.props.mainTableData[0].data
            });
			this.setButtonsEnableDisable(this.state.total);
		} else {
            await this.getDataExport(this.state.searchYear, contractTypes, query);
            let exportData = this.props.mainExportData[0].data;
            if (dynamicFunction) {
                exportData = dynamicFunction(this.props.mainExportData[0].data);
            }

            this.setState({
				apiCallCompleted: this.props.apiCallCompleted,
				exportData: exportData
			});
		}
	};

	loadDetailsData = async (searchInput, pageNoInput, pazeSizeInput, flagExportData, sortOrder, sortField, dynamicFunction) => {
		const { selectedMarkingTeamId, contractTypes, selectedMarkingTeamCode, detailsKeyField } = this.state;

		sortOrder = sortOrder ? sortOrder : 'asc';
		sortField = sortField ? sortField : detailsKeyField;
		let query = {
			sortOrder,
			sortField,
			page: pageNoInput,
			sizePerPage: pazeSizeInput,
			searchText: searchInput,
			flagExportData
        };
		await this.getDetailsData(selectedMarkingTeamId, this.state.searchYear, selectedMarkingTeamCode, contractTypes, query);
        if (flagExportData === false) {
			this.setState({
				...this.state,
				setSearchBoxBlur: true,
				keyField: detailsKeyField,
				pageNo: pageNoInput,
				pageSize: pazeSizeInput,
				detailsSortOrderInput: sortOrder,
				detailsSortFieldInput: sortField,
				apiCallCompleted: this.props.apiCallCompleted,
				total: this.props.detailsTableData[0].total,
				tableData: this.props.detailsTableData[0].data,
				allDetailsData: this.props.detailsTableData[0].data
			});
			this.setButtonsEnableDisable(this.state.total);
		} else {
            var exportData = this.props.detailsExportData[0].data;
            if (dynamicFunction) {
                exportData = dynamicFunction(this.props.detailsExportData[0].data);
            }

            this.setState({
				apiCallCompleted: this.props.apiCallCompleted,
				exportData: exportData
			});
		}
	};

	setButtonsEnableDisable = total => {
		if (total === 0) {
			if (this.state.flagDetailsData === false) document.getElementById('btnSelect').disabled = true;
			document.getElementById('btnExport').disabled = true;
		} else {
			document.getElementById('btnSelect').disabled = false;
			document.getElementById('btnExport').disabled = false;
		}
	};

    handleTableChange = (type, state) => {
		this.setState({ blurSearchBoxOnPageChange: true });
		let { sortOrder, sortField, page, sizePerPage } = state;
		const { keyField, searchValue, flagExportData } = this.state;
		sortOrder = sortOrder ? sortOrder : 'asc';
		sortField = sortField ? sortField : keyField;
		if (this.state.flagDetailsData === false) this.loadMainData(searchValue, page, sizePerPage, flagExportData, sortOrder, sortField);
		else if (this.state.flagDetailsData === true) this.loadDetailsData(searchValue, page, sizePerPage, flagExportData, sortOrder, sortField, null);
		this.setState({ clearRefiner: true });
		this.componentRef.scrollIntoView({ behavior: 'smooth' });
	};

    getExportData = async props => {
        this.setState({ setSearchBoxBlur: true });
		const { keyField } = this.state;
		let searchValue = '';
		let flagExportData = true,
			sortOrder = 'asc',
			sortField = keyField,
			page = 0,
            sizePerPage = 0;
        if (this.state.flagDetailsData === false) await this.loadMainData(searchValue, page, sizePerPage, flagExportData, sortOrder, sortField, props.dynamicFunction);
		else if (this.state.flagDetailsData === true) await this.loadDetailsData(searchValue, page, sizePerPage, flagExportData, sortOrder, sortField, props.dynamicFunction);

        if (this.state.flagDetailsData == true && props.dynamicFunction) {
        }
        props.onExport(this.state.exportData);
	};

	handleSelectClick = event => {
		this.setState({ setSearchBoxBlur: true, setSearchFieldHit: false });
		const { pageNoInit, pageSize, searchValue, detailsColumns, detailsSortFieldInput, flagExportData } = this.state;
		this.setState({
			columns: [],
			apiCallCompleted: false,
			total: 0
		});

		if (this.state.flagDetailsData === false) {
			let searchInput = '',
				selectedPageSize = pageSize;
			let ddPageSize = document.getElementById('pageDropDown');
			if (ddPageSize && document.getElementById('pageDropDown').textContent) {
				selectedPageSize = parseInt(document.getElementById('pageDropDown').textContent.trim()) || pageSize;
			}

			document.getElementById('btnSelect').style.display = 'block';
			let sortOrder = 'asc',
				sortField = detailsSortFieldInput;
			this.loadDetailsData(searchInput, pageNoInit, selectedPageSize, flagExportData, sortOrder, sortField, null);
			
			this.setState({
				flagDetailsData: true,
				columns: detailsColumns,
				mainSearchTextInput: searchValue,
				searchValue: ''
			});
		} else if (this.state.flagDetailsData === true) {
			this.setState({
				flagDetailsData: false,
				columns: this.state.mainColumns,
				apiCallCompleted: true,
				keyField: this.state.mainKeyField,
				searchValue: this.state.mainSearchTextInput,
				pageNo: this.state.mainPageNo,
				pageSize: this.state.mainPageSize,
				sortOrder: this.state.mainSortOrderInput,
				sortField: this.state.mainSortFieldInput,
				total: this.props.mainTableData[0].total,
				tableData: this.props.mainTableData[0].data
			});
			document.getElementById('btnSelect').style.display = 'none';
		}
	};

	handleOnSelectRow = (row, isSelect) => {
		this.setState({ setSearchBoxBlur: true, setSearchFieldHit: false });
		if (isSelect) {
			this.setState(() => ({
				selected: [...this.state.selected, row.rowId],
				selectedMarkingTeamId: row.markingTeamId,
				selectedMarkingTeamCode: row.markingTeamCode,
				selectedRowId: row.rowId,
				setSearchBoxBlur: true
			}));
		} else {
			this.setState(() => ({
				selected: this.state.selected.filter(x => x !== row.rowId)
			}));
		}
	};

	handleRefinementChange = async (refined) => {
		this.setState({ tableData: refined });
	};
	
	handleRefinerToggle = async () => {
		const { refinerOpen } = this.state;
		this.setState({ refinerOpen: !refinerOpen });
	};
	
	handleDetailsRefinerToggle = async () => {
		const { refinerDetailsOpen } = this.state;
		this.setState({ refinerDetailsOpen: !refinerDetailsOpen });
	};

	getSearchData = async () => {
		this.setState({ setSearchFieldHit: true });
		const { pageNoInit, pageSize, flagExportData, mainSortOrderInput, mainSortFieldInput, detailsSortOrderInput, detailsSortFieldInput } = this.state;
		const searchValue = document.getElementById('txtSearch').value;
		let selectedPageSize = pageSize;
		let ddPageSize = document.getElementById('pageDropDown');
		if (ddPageSize && document.getElementById('pageDropDown').textContent) {
			selectedPageSize = parseInt(document.getElementById('pageDropDown').textContent.trim()) || pageSize;
		}

		this.setState({ apiCallCompleted: false, total: 0, tableData: [], allData: [] });
		if (this.state.flagDetailsData === false)
			this.loadMainData(searchValue, pageNoInit, selectedPageSize, flagExportData, mainSortOrderInput, mainSortFieldInput);
		else if (this.state.flagDetailsData === true)
			this.loadDetailsData(searchValue, pageNoInit, selectedPageSize, flagExportData, detailsSortOrderInput, detailsSortFieldInput, null);
	};

	updateYear = async year => {
		this.state.isFiltering = true;
		this.state.searchYear = year;

		const { mainKeyField, searchValue, pageNoInit, pageSizeInit, flagExportData } = this.state;
		let sortOrder = 'asc',
			sortField = mainKeyField;
		this.loadMainData(searchValue, pageNoInit, pageSizeInit, flagExportData, sortOrder, sortField);
		this.state.isFiltering = false;
	};

	render() {
		let {
			contractTypes,
			columns,
			apiCallCompleted,
			tableData,
			allData,
			allDetailsData,
			pageNo,
			total,
			pageSize,
			flagDetailsData,
			selectedRowId,
			searchValue,
			searchYear,
			isFiltering,			
			refinerOpen,
			refinerDetailsOpen			
		} = this.state;

		const handleUpdateYear = this.updateYear;

		return (
			<ErrorBoundary>
				<div ref={el => (this.componentRef = el)}>
					<YearSelector numberOfPreviousYears={1} numberOfFutureYears={1} year={searchYear} grouping={this.state.grouping} updateYear={handleUpdateYear} />	
					<Section>
						{!flagDetailsData && 
							<Refiner
								disabled={isFiltering}
								fields={refinerFields}
								open={refinerOpen}
								data={allData}
								onRefinementChange={this.handleRefinementChange}
								onPanelToggleClick={this.handleRefinerToggle}
							/>
						}

						{flagDetailsData &&
							<Refiner
								disabled={isFiltering}
								fields={refinerDetailFields}
								open={refinerDetailsOpen}
								data={allDetailsData}
								onRefinementChange={this.handleRefinementChange}
								onPanelToggleClick={this.handleDetailsRefinerToggle}
							/>
						}
					</Section>
					<AppointeeDatatableView
						contractTypes={contractTypes}
						columns={columns}
						apiCallCompleted={apiCallCompleted}
						tableData={tableData}
						flagDetailsData={flagDetailsData}
						searchValue={searchValue}
						selectedRowId={selectedRowId}
						handleChange={this.handleChange}
						focusSearchInputField={this.focusSearchInputField}
						getExportData={this.getExportData}
						handleSelectClick={this.handleSelectClick}
						handleOnSelectRow={this.handleOnSelectRow}
						handleTableChange={this.handleTableChange}
					/>
				</div>
			</ErrorBoundary>
		);
	}
}

export default AppointeeDatatable;
